import React from "react";
import { ServiceDetailsBreakdown } from "../../../../../types";
import { Modal, Type } from "mesh-component-library";
import { SpaceBetweenFlex } from "../DetailedLocationReviewV2.styles";
import { CustomAddressSuccessPayload } from "../../../actions";

type CustomAddressProps = {
  location: CustomAddressSuccessPayload;
  towServiceDetails: ServiceDetailsBreakdown;
};

export const CustomAddressDisplay = ({ location, towServiceDetails }: CustomAddressProps) => (
  <>
    <Modal.Header
      title={
        <Type size="4xl" weight="bold" variant="default">
          Preferred tow destination
        </Type>
      }
    />
    <Modal.Subheader style={{ paddingRight: "16px" }}>
      <Type weight="bold" size="sm">
        {location.formatted_address}
      </Type>
    </Modal.Subheader>
    <Modal.Subheader style={{ paddingRight: "16px" }}>
      <SpaceBetweenFlex>
        <Type weight="thin">{`Base rate up to ${towServiceDetails.towIncludedDistanceQty} miles`}</Type>
        <Type weight="thin">{`$${towServiceDetails.displayCost}.00`}</Type>
      </SpaceBetweenFlex>
      <SpaceBetweenFlex>
        <Type weight="thin">{`${
          location.towInfo.overMileageDistance
        } additional miles at $${towServiceDetails.costPerMile.toFixed(2)}/mile`}</Type>
        <Type weight="thin">{`$${location.towInfo.overMileageCost}`}</Type>
      </SpaceBetweenFlex>
    </Modal.Subheader>
    <Modal.Subheader hasBorder={false} style={{ paddingRight: "16px" }}>
      <SpaceBetweenFlex>
        <Type weight="bold">Amount due</Type>
        <Type weight="bold">{`$${location.towInfo.totalTowCost}`}</Type>
      </SpaceBetweenFlex>
    </Modal.Subheader>
  </>
);
